import { Theme } from '@mui/material';

import { Hash } from './types';

import { Style } from '../../../../common/types';

type ProductStyle = {
  product: Style;
  figure: Style;
} & { [key in Hash]: Style };

export default (): ProductStyle => ({
  // Component Style
  product: {
    'position': 'relative',

    'flex': 1,

    'borderRadius': 3,
    'borderWidth': '2px',
    'borderStyle': 'solid',
    'borderColor': 'divider',

    'p': 1,

    'transition': (theme: Theme) =>
      `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

    '&:focus': {
      outline: 'transparent'
    },

    '&:hover': {
      '& img': {
        transform: 'scale(1.1)',
        opacity: 0.75
      },

      '& figcaption': {
        opacity: 1
      }
    }
  },
  figure: {
    'width': '100%',
    'height': '400px',

    'backgroundColor': 'rgba(0, 0, 0, 0.25)',
    'borderRadius': 2,

    'overflow': 'hidden',

    'mb': 1,

    'transition': (theme: Theme) =>
      `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

    '& img': {
      width: '100%',
      height: '100%',

      objectFit: 'cover',

      borderRadius: 2,

      transform: 'scale(1)',

      transition: (theme: Theme) =>
        `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut} !important`
    },

    '& figcaption': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      borderRadius: 2,

      transition: (theme: Theme) =>
        `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`
    }
  },

  // Color Style
  sportsbook_product: {
    '&:active': {
      borderColor: 'success.main'
    }
  },
  livecasino_product: {
    '&:active': {
      borderColor: 'primary.main'
    }
  },
  slots_product: {
    '&:active': {
      borderColor: 'info.main'
    }
  },
  fishhunter_product: {
    '&:active': {
      borderColor: 'warning.main'
    }
  }
});
